<section class="section" *ngIf="_logosData">
  <div class="section-container">
    <div class="section-customer-logos">
      <figure class="customer-logos" *ngFor="let logo of logosData.logos">
        <img src="{{ logo.fields.file.url }}" alt="{{ logo.fields.title }}" />
      </figure>
    </div>
    <app-trust-pilot
      [bgWhite]="false"
      [paddTop]="true"
    ></app-trust-pilot>
  </div>
</section>
